import React, {Component} from 'react';
import {login, fieldChange} from '../../actions/users';
import {connect} from 'react-redux'
import Logo from '../../logo.png';
import {withAlert} from 'react-alert'
import axios from 'axios';
import Config from '../../config';

/**
 * Forgot password popup
 */
class PopupForgotPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            forgotemail: ''
        };
    }

    validateForm() {
        return this.state.forgotemail.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();

        axios.get(Config.api.getDomain() + 'user/retrievePassword?email=' + this.state.forgotemail).then(() => {
            alert('Tack, en administratör skicka ut nytt lösenord till dig');
        }).catch(() => {
            alert('E-postadressen är felaktig eller finns inte registrerad')
        });
    };

    render() {
        return (
            <div className='popup'>
                <div className='popup_inner'>
                    <button className='close' onClick={this.props.closePopup}/>
                    <h1>Glömt lösenord</h1>
                    <p className="ingress">
                      Kontakta <a href="mailto:dack@europcar.se">dack@europcar.se</a> om du glömt ditt lösenord eller användarnamn.
                    </p>

                    {/*

                    <div className="labelforforgotpassword">
                        Ange din e-postadress så kommer en administratör skicka ut nytt lösenord till dig.
                    </div>
                    <div className="formforforgotpassword">
                        <form onSubmit={this.handleSubmit}>
                            <input
                                type="text"
                                name="email"
                                id="forgotemail"
                                placeholder="E-postadress"
                                value={this.state.email}
                                onChange={this.handleChange}
                            />
                            <input
                                type="submit"
                                disabled={!this.validateForm()}
                                name="submit"
                                className="forgotsubmit"
                                value="Skicka"
                            />
                        </form>
                    </div>

                    */}

                </div>
            </div>
        );
    }
}

/**
 * Login
 */
class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            password: ''
        };
    }

    validateForm() {
        return this.state.email.length > 0 && this.state.password.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });

    };

    handleOnFocus = event => {
        this.props.fieldChange();
    }

    handleSubmit = event => {
        event.preventDefault();

        this.props.login(this.state.email, this.state.password).then(response => {
            if (response && response.token) {
                this.props.router.push('/');
            }
        });
    };

    togglePopup = (event) => {
        event.preventDefault();

        this.setState({
            showPopup: !this.state.showPopup
        });
    };

    render() {

        const {submitting,failedAttempt} = this.props;
        let submitButtonTitle="Logga in";
        if (submitting){
            submitButtonTitle="Bearbetning";
        }
        let errorClass="";
        if (failedAttempt){
            errorClass="js-form-error";
        }

        return (
            <div className="loginBoxVerticalWrapper">
                <div className="loginBoxInnerWrapper">
                    <h1>Wheel IT</h1>
                    <div className="loginBox">
                        <div className="logoBox">
                            <img src={Logo} alt="Logotype" width="150"/>
                        </div>
                        <div className="formBox">
                            <h2>Logga in</h2>
                            <form onSubmit={this.handleSubmit.bind(this)}>
                                <input
                                    type="text"
                                    name="email"
                                    id="email"
                                    placeholder="Användarnamn"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    onFocus={this.handleOnFocus}
                                    className={errorClass}
                                />
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    placeholder="Lösenord"
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    onFocus={this.handleOnFocus}
                                    className={errorClass}
                                />
                                {failedAttempt &&
                                <div className={"error-msg"}>
                                    Tyvärr, fel användarnamn eller / och lösenord!
                                </div>
                                }

                                <a className="forgot" onClick={this.togglePopup.bind(this)}>Glömt lösenord</a>
                                <input
                                    type="submit"
                                    disabled={!this.validateForm()}
                                    name="submit"
                                    value={submitButtonTitle}
                                />
                            </form>
                        </div>
                    </div>
                </div>
                {this.state.showPopup &&
                <PopupForgotPassword closePopup={this.togglePopup.bind(this)}/>
                }
            </div>
        );
    }
}


/**
 * Map state to properties
 */
const mapStateToProps = (state) => ({
    submitting:state.users.submitting,
    failedAttempt:state.users.failedAttempt
});


/**
 * Map actions to properties
 */
const mapDispatchToProps = dispatch => {
    return {
        fieldChange:() => dispatch(fieldChange()),
        login: (email, password) => dispatch(login(email, password))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withAlert(Login));



// WEBPACK FOOTER //
// ./src/components/Login/index.js